import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedExclamationMdBoldIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 2, height: 24, viewBox: '0 0 2 24', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M1.75 5.75v9a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-9A.74.74 0 0 1 1 5a.76.76 0 0 1 .75.75M1 19c-.562 0-1-.437-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '3206b49f509456437a8765b68d3ef3aa__a' },
            React.createElement("path", { d: 'M0 0h2v24H0z' })))));
const ForwardRef = forwardRef(LabelPairedExclamationMdBoldIcon);
export default ForwardRef;
